import { mapVenueDetailsType, useFindVenueSuspense } from '@api';
import { CompanyVenueView } from './components';

type CompanyVenuePropsType = {
  venueId: string;
};

export const CompanyVenue: React.FC<CompanyVenuePropsType> = ({ venueId }) => {
  const { data: venue } = useFindVenueSuspense(venueId, {
    query: {
      select: (response) => mapVenueDetailsType(response.data),
    },
  });

  return <CompanyVenueView venue={venue} />;
};
